import { apiCall } from "../../../api-calls/api-call"
import { GameCategoryOrderBaseType, GameCategoryOrderType } from "../store/game-category-order.store"

export const getGameCategoryOrder = async() => {
  return apiCall({
    method: "GET",
    path: "buff-play/game-category-order",
  })
}

export const createTransactionBuffPlay = async(data: GameCategoryOrderBaseType) => {
  return apiCall({
    method: "POST",
    path: "buff-play/game-category-order",
    body: { ...data, metadata: {} },
  })
}

export const updateGameCategory = async(data: GameCategoryOrderType) => {
  return apiCall({
    method: "PUT",
    path: "buff-play/game-category-order",
    body: { ...data },
  })
}

export const getGamePlatforms = async() => {
  return apiCall({
    method: "GET",
    path: "buff-play/games",
    query: { page: 1, limit: 50 },
  })
}
